// global-ticket.service.ts
import { Injectable, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({ providedIn: 'root' })
export class GlobalTicketService {
  private modalRef?: NgbModalRef;
  public currentPedidoId?: number;

  constructor(private modalService: NgbModal) {}

  open(template: TemplateRef<any>, idPedido: number, config: any = { size: 'xl', backdrop: true, keyboard: true }) {
    this.currentPedidoId = idPedido;
    this.modalRef = this.modalService.open(template, config);
    return this.modalRef;
  }

  close() {
    this.modalRef?.close();
    this.currentPedidoId = undefined;
  }
}
